import React from "react";

/** Karkhana: a workshop with a sawtooth roof. */
const KarkhanaIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 20V10.5l4.5-3v3l4.5-3v3l4.5-3V20" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
      <path d="M16.5 20V4.5h3V20M2 20h20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.5 14.5h2M10.5 14.5h2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
};

export default KarkhanaIcon;
